import React from 'react';

import { useIntl } from '@utils/intl';
import { BookingIcon } from '@views/shared/BookingIcon';
import { BOOK_CATEGORY_HOME, getBookingIcon } from '@views/shared/consts';
import { useGoToBookingPage } from '@views/shared/utils/useGoTo';
import { Panel } from '@views/Home/Bookings/Panel';

export default function HomeOffice() {
  const { t } = useIntl();

  const makeABooking = useGoToBookingPage();

  return (
    <Panel
      icon={<BookingIcon name={getBookingIcon(BOOK_CATEGORY_HOME)} />}
      name={t('Home.Bookings.HomeOffice.title')}
      onAction={() => makeABooking({ type: BOOK_CATEGORY_HOME })}
    />
  );
}
